import React, { Component } from 'react';
import AccountMenu from '../Modules/AccountMenu';
import AddButtons from '../Modules/Kennis/AddButtons';
import KennisOverzicht from '../Modules/Kennis/KennisOverzicht';
import KennisOverzichtContent from '../Modules/Kennis/KennisOverzichtContent';


class OpleidingBeheren extends Component {

    render() {
        return (
            <div className="route">
                <AccountMenu />
                <div className="grey-bg">
                    <h1 className="pageTitle">
                        Beheren van permanente educatie
                    </h1>
                    <p>Op deze webpagina kunt u uw permanente educatie activiteiten invullen.</p>
                    <p>
                        Op deze pagina kunt u uw kennis/permanente educatie invullen. Er is een keuzemenu met opleidingen, cursussen en bijeenkomsten die aangemeld zijn bij het Constructeursregister. Deze hebben ook een referentienummer. Onbekende opleidingen, cursussen en bijeenkomsten hebben geen referentienummer. Definitieve waardering van deze invoer vindt plaats bij controle van uw invoer.
                    </p>
                </div>
                <div className="grey-bg">
                    <AddButtons />
                    {/*Old accordions <OpleidingPanels /> */}
                </div>
                <div className="grey-bg">
                    <h5><strong>Overzicht van permanente educatie</strong></h5>
                    <p>De volgende permanente educatie heeft u ingevoerd.</p>
                    <KennisOverzicht />
                </div>
                <div className="grey-bg">
                    <KennisOverzichtContent />
                </div>
            </div>
        );
    }
}

export default OpleidingBeheren;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/OpleidingBeheren.js